import { useDispatch, useSelector } from "react-redux";
import { MapIndicator } from "../index";
import { getIcons } from "_helpers/getIcons";
import { vehicleActions } from "_store";

export { ConnectedBusIndicator }

/**
 * Indicateur du nombre de bus connectés
 * Utilisé sur la page géolocalisation
 * @param {*} param0 
 * @returns 
 */
function ConnectedBusIndicator({value})  {

    const dispatch = useDispatch();

    const showAllGeoloc = useSelector(state => state.vehicles.showAllGeoloc);

    const handleToggleAllVehicles = () => {
        dispatch(vehicleActions.toogleShowAllVehicles());
    }

    const bus = {
            title: "Vehicules connectés",
            value: value,
            icon: getIcons("directionsBusFilledOutlinedWhite"),
            color: 'global-blue',
            isActiveClass: 'bg-global-blue text-white',
            clickable: true,
            isActive: showAllGeoloc,
            action: () => handleToggleAllVehicles()
        }
    
    return (
        <div className={"map-legend"}>
            <div className={'flex item-center mt-16 ml-4'}>
                <MapIndicator info={bus} />
            </div>
        </div>


    )
}